import {
  Swiper,
  Navigation,
  Scrollbar,
  Pagination,
  Grid,
  Thumbs,
} from 'swiper';

Swiper.use([Navigation, Scrollbar, Pagination, Grid, Thumbs]);

export default (swiperNode, options = {}) => {
  const defaultOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
  };

  const swiperOptions = {
    ...defaultOptions,
    ...options,
  };

  // Initialize Swiper with merged options
  const swiper = new Swiper(swiperNode, swiperOptions);

  return swiper;
};
